// Action Object creators:

import {toggleHasBeenEditedByTheUserProp} from "./mapActions";
import {featureTourIsOpenSelector, filterFieldBeingManuallyEditedSelector} from "../selectors";

export const UPDATE_OPTION_ACTION = 'UPDATE_OPTION_ACTION'
export const updateOptionAction = (opt) => ({
	type: UPDATE_OPTION_ACTION,
	opt,
})

export const UPDATE_FILTER_FIELD_BEING_MANUALLY_EDITED_ACTION = 'UPDATE_FILTER_FIELD_BEING_MANUALLY_EDITED_ACTION'
export const updateFilterFieldBeingManuallyEditedAction = (fieldName) => ({
	type: UPDATE_FILTER_FIELD_BEING_MANUALLY_EDITED_ACTION,
	fieldName,
})

export const TOGGLE_FEATURE_TOUR_ACTION = 'TOGGLE_FEATURE_TOUR_ACTION'
const toggleFeatureTourAction = (featureTourIsOpen) => ({
	type: TOGGLE_FEATURE_TOUR_ACTION,
	featureTourIsOpen,
})

// Helpers

// const shouldSaveInfo = (getReduxState) => {
// 	return getReduxState() // check the cache etc
// }


// Actions used by UI:

// *** map options specific

export const openOption = (opt = undefined) => {
	return (dispatch, getReduxState) => {
		opt && dispatch(updateOptionAction(opt))
	}
}

export const toggleOption = (opt) => {
	return (dispatch, getReduxState) => {
		const currentOpt = getReduxState().ui.opt
		dispatch(updateOptionAction(currentOpt === opt ? null : opt))
	}
}

export const onCloseButton = () => {
	return (dispatch, getReduxState) => {
		dispatch(updateOptionAction(null))
	}
}

export const toggleFeatureTour = (setToThisValue = undefined) => {
	return (dispatch, getReduxState) => {
		const reduxState = getReduxState()
		const featureTourIsOpen = featureTourIsOpenSelector(reduxState)
		const _featureTourIsOpen = setToThisValue === undefined ? !featureTourIsOpen : setToThisValue
		dispatch(toggleFeatureTourAction(_featureTourIsOpen))
	}
}


// *** Community Summary

// TURNING IT ON:
// mark it as being edited in ui to show viz (TODO: turn the state capture that it's "on" but no filtering has been applied?)
// mark field as editedByTheUser
// TURNING IT OFF:
// close visualization (flip ui bool)
// turn off editedByTheUser

// BIGGER IDEA: button serves two purpose: (1) apply/remove filter and (2) open/close viz

export const onToggleFilterFieldCustomEditingButton = (fieldName = undefined) => {
	return (dispatch, getReduxState) => {
		const reduxState = getReduxState()
		const filterFieldBeingManuallyEdited = filterFieldBeingManuallyEditedSelector(reduxState)
		
		const fieldIsBeingToggledOn = filterFieldBeingManuallyEdited !== fieldName
		const _fieldNameBeingManuallyEditedIfAny = fieldIsBeingToggledOn && fieldName
		
		dispatch(updateFilterFieldBeingManuallyEditedAction(_fieldNameBeingManuallyEditedIfAny))
		fieldName && dispatch(toggleHasBeenEditedByTheUserProp(fieldName, fieldIsBeingToggledOn))
	}
}
